import { InitFeatureParams } from '../types'
import { getRoutes } from './routes'

export const initStudentManagement = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
